'use strict';

angular
  .module('checker.data')
  .factory('CheckerData', CheckerData);

CheckerData.$inject = ['$q', '$http', '$timeout', 'API_META'];

function CheckerData($q, $http, $timeout, API_META) {

  var availableDrugs           = [],
      availableDrugClassNames  = [],
      availableDrugTradeNames  = [],
      availableComeds          = [],
      availableComedClassNames = [],
      availableComedTradeNames = [],
      availableInteractions    = [];

  return {
    fetchApiDrugs: fetchApiDrugs,
    fetchDrugClassNames: fetchDrugClassNames,
    fetchSelectedInteractions: fetchSelectedInteractions,
    fetchAllInteractions: fetchAllInteractions,
    // To Do - these seem unused, clarify.
    // getComeds: function(){
    //   return availableComeds;
    // },
    // getDrugs: function(){
    //   return availableDrugs;
    // },
    getInteractions: function(){
      return availableInteractions;
    }
  };

  /////////////////////////////////////////

  function fetchApiDrugs(lang, viewAll) {
    var data = [];
    return fetchDrugs(lang).then(function(drugs){
      availableDrugs = drugs;
      data[0] = drugs;
      return fetchDrugClassNames(lang).then(function(dClassData) {
        availableDrugClassNames = dClassData;
        data[1] = dClassData;
        return fetchComeds(lang).then(function(comeds) {
          availableComeds = comeds;
          data[2] = comeds;
          return fetchComedClassNames(lang).then(function(cClassData) {
            availableComedClassNames = cClassData;
            data[3] = cClassData;
            return fetchDrugTradeNames(lang, viewAll).then(function(dTradeData) {
              availableDrugTradeNames = dTradeData;
              data[4] = dTradeData;
              return fetchComedTradeNames(lang, viewAll).then(function(cTradeData) {
                availableComedTradeNames = cTradeData;
                data[5] = cTradeData;
                  return data;
              });              
            });
          });
        });  
      });
    });
  }

  function fetchSelectedInteractions(drugs, comeds, lang){
    var deferred = $q.defer(),
        interactionUrl = ("INTERACTIONS_ENDPOINT") + "_" + lang.toUpperCase();

    if (drugs.length === 0) {
      availableInteractions = []
      deferred.resolve([]);
    } else {
      makeDataRequest(API_META[interactionUrl], 'GET', drugIdParams(drugs, comeds)).then(function(interactions){
        availableInteractions = interactions.data;
        deferred.resolve(interactions.data);
      });
    }

    return deferred.promise;
  }

  /////////////////////////////////////////

  function drugIdParams(drugs, comeds) {
    return {
      "drug_ids[]": drugs.map((drug)=>drug.id), 
      "co_drug_ids[]": comeds.map((drug)=>drug.id)
    }
  }

  function fetchComedClassNames(lang) {
    var url = 'COMED_CLASSES_ENDPOINT' + "_" + lang.toUpperCase()
    return makeDataRequest(API_META[url]).then(function(classNames){
      return classNames.data;
    });
  }

  function fetchDrugClassNames(lang) {
    var url = 'DRUG_CLASSES_ENDPOINT' + "_" + lang.toUpperCase()
    return makeDataRequest(API_META[url]).then(function(classNames){
      return classNames.data;
    });
  }

  function fetchComeds(lang) {
    if (window.location.href.indexOf('admin') > -1){
      return makeDataRequest(API_META['UNAPPROVED_AND_COMED_ENDPOINT']).then(function(co_drugs){
        return co_drugs.data;
      });
    } else {
      var url = 'COMEDS_ENDPOINT' + "_" + lang.toUpperCase()
      return makeDataRequest(API_META[url]).then(function(co_drugs){
        return co_drugs.data;
      });
    }
  }

  function fetchDrugs(lang) {
    if (window.location.href.indexOf('admin') > -1){
      return makeDataRequest(API_META['UNAPPROVED_AND_PRIMARY_ENDPOINT']).then(function(drugs){
        return drugs.data;
      });
    } else {
      var url = 'DRUGS_ENDPOINT' + "_" + lang.toUpperCase()
      return makeDataRequest(API_META[url]).then(function(drugs){
        return drugs.data;
      });
    }
  }

  function fetchDrugTradeNames(lang, viewAll) {
    if (lang === 'en' && !viewAll) {
      return makeDataRequest(API_META['PRIMARY_TRADE_NAMES_ENDPOINT']).then(function(tradeNames){
        return tradeNames.data;
      });
    } else {
      return $q.resolve([]);
    }
  }

  function fetchComedTradeNames(lang, viewAll) {
    if (lang === 'en' && !viewAll) {
      return makeDataRequest(API_META['COMED_TRADE_NAMES_ENDPOINT']).then(function(comedTradeNames){
        return comedTradeNames.data;
      });
    } else {
      return $q.resolve([]);
    }
  }

  function fetchAllInteractions(){
    return makeDataRequest(API_META['VIEW_ALL_ENDPOINT']).then(function(interactions){
      availableInteractions = interactions.data;
      return interactions.data;
    });
  }

  function makeDataRequest(url, method = 'GET', params = {}) {
    var deferred = $q.defer();

    var req = {
      method: method,
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': API_META['X-Api-Key']
      },
      params: params
    };

    $http(req).then(function (data) {
      deferred.resolve(data);
    }, function(response){
      deferred.reject(response);
    });

    return deferred.promise;
  }

}
